import Footer from "../components/Footer";
import ContactForm from "../components/ContactForm";
import ContactIntro from "../components/ContactIntro";
import Seo from "../components/Seo";
import { URLS } from "../utils/constants";

const Contact = () => {
  const meta = URLS.contact;

  return (
    <div className="contact-page">
      <Seo title={meta.title} description={meta.desc} keywords={meta.keywords} image={meta.metaImage} path={meta.path} />
      <ContactIntro />

      <ContactForm />

      <Footer />
    </div>
  );
};

export default Contact;
